import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class GlobalNotificationServices {
    constructor(private http: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string) { };

    getglobalNotifications(filter: any) {
        return this.http.post(`${this.apiEndPoint}/gwdevice/eventnotification/_search?size=10000`, filter);
    }
    updateglobalNotifications(id: any, filter: any) {
        return this.http.put(`${this.apiEndPoint}/gwdevice/eventnotification/${id}/_update`, filter);
    }
    getEventTypes() {
        return this.http.get(this.apiEndPoint + '/_/notification_page_dropdown')
    }
    getAlarmTypes() {
        return this.http.get(this.apiEndPoint + '/_/2.0/alarm_page_dropdown')
    }

    word = "hello";
}